module.exports = function(app) {
    app.directive('waitCursor', ['services', '$window', 'sessionData',
        function (services, $window, sessionData) {
            return {
                restrict: 'A',
                replace: true,
                template: require('directives/common/waitCursor.html'),
                controller: [function () {
                }],
                link: function (scope, element, attrs, controller) {
                    if (scope[attrs['waitCursor']] == undefined) {
                        console.error('The property that the wait cursor is watching is undefined.')
                    }
                    scope.$watch(attrs['waitCursor'], function(theServiceIsRunning) {
                        // I want to flip showWaitCursor here
                        scope.showWaitCursor = theServiceIsRunning;
                    });
               }
            };
        }]);

}
